<template>
  <div>
    <WebHeaderView :title="'外水领取记录'" />
    <div class="page-content">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <div v-if="isnorecord && isnorecord == 0">
          <van-empty description="暂无记录" />
        </div>
        <van-list
          v-else
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <FanShuiRecoedItem
            v-for="(item, index) in list"
            :key="index"
            :item="item"
          />
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import WebHeaderView from '@/components/Header/index.vue'
import { FanShuiRecoedItem } from './components/index'
export default {
  name: 'WaiShuiRecordView',
  components: {
    WebHeaderView,
    FanShuiRecoedItem
  },
  data () {
    return {
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      isnorecord: null,
      params: {
        per_page: 20,
        page: 1
      }
    }
  },
  methods: {
    onRefresh () {
      this.params.page = 1
      this.isnorecord = null
      this.finished = false
      this.loading = true
      this.refreshing = true
      this.onLoad()
    },
    onLoad () {
      if (this.refreshing) {
        this.list = []
        this.refreshing = false
      }
      this.getDta()
    },
    async getDta () {
      await this.$http({
        method: 'post',
        url: 'claimLogs',
        data: this.params
      }).then(data => {
        this.loading = false
        this.isnorecord = data.data.total
        this.list = this.list.concat(data.data.items)
        if (this.list.length >= data.data.total) {
          this.finished = true
        } else {
          this.params.page += 1
        }
      })
    }
  }
}
</script>

<style></style>
